import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import JobLimitAlert from '~/components/shared/job_limit_alert';

const JobLimitAlertChecker = ({
  showJobLimitAlert, setShowJobLimitAlert, placement = 'top', children, title, message,
}) => {

  const renderPopover = (popoverProps) => (
    <Popover
      id="popover-job-limit"
      {...popoverProps}
    >
      <Popover.Content className="bg-grey-lightest">
        <JobLimitAlert
          onClose={() => setShowJobLimitAlert(false)}
          title={title || 'Upgrade your Subscription'}
          message={message || 'Collaborate with your team by sharing candidate profiles and feedback in one place.'}
        />
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger placement={placement} overlay={renderPopover} trigger="manual" show={showJobLimitAlert}>
      { children }
    </OverlayTrigger>
  );
};

export default JobLimitAlertChecker;
